import { useState } from 'react';
import AlertContext from './AlertContext';

const AlertProvider = ({children}) => {
    const [state, setState] = useState({
        text: '',
        type: 'success',
        open: false,
    });

    return (
        <AlertContext.Provider
            value={{
                state,
                hide: () => setState(prevState => ({...prevState, open: false})),
                showErrorAlert: text => setState({text, type: 'error', open: true}),
                showSuccessAlert: text => setState({text, type: 'success', open: true}),
            }}
        >
            {children}
        </AlertContext.Provider>
    );
};

export default AlertProvider;
